import { baseRequst, bvaRequest } from "./Network";
const request = async (apiFunc, ...args) => {
  try {
    const res = await apiFunc(...args);
    return res.data;
  } catch (error) {
    throw error?.response?.data || error;
  }
};

// 发送验证码
export const authSendVerifyCode = async (email) => {
  return request(
    baseRequst,
    "/auth/send-verify-code",
    "post",
    null,
    { params:{email} }
  );
};

export const authRegister = async (data) => {
  return request(
    baseRequst,
    "/auth/register",
    "post",
    data,
  );
};

export const authLogin = async (data) => {
  return request(
    baseRequst,
    "/auth/login",
    "post",
    data,
  );
};
export const authVerifyCodeLogin = async (data) => {
  return request(
    baseRequst,
    "/auth/verify-code-login",
    "post",
    data,
  );
};
export const authChangePwd = async (data) => {
  return request(
    baseRequst,
    "/auth/change-password",
    "post",
    data,
  );
};

export const authLogout = async () => {
  return request(
    bvaRequest,
    "/auth/logout",
    "get",
  );
};